import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/lib/i18n";

export default function NotFoundPage() {
    const { t, p } = useLang();
    useEffect(() => {
        document.title = `${t("pageNotFound")} | ${t("siteName")}`;
        let robots = document.querySelector('meta[name="robots"]');
        if (!robots) { robots = document.createElement("meta"); robots.setAttribute("name", "robots"); document.head.appendChild(robots); }
        robots.setAttribute("content", "noindex, nofollow");
        return () => { const el = document.querySelector('meta[name="robots"]'); if (el) el.remove(); };
    }, [t]);

    return (
        <div className="mx-auto max-w-2xl px-4 py-20 text-center" data-testid="not-found-page">
            <div className="font-display font-black text-7xl text-brand-red mb-4" aria-hidden="true">404</div>
            <h1 className="font-display font-black text-3xl md:text-4xl text-brand-black dark:text-white mb-3" data-testid="not-found-title">{t("pageNotFound")}</h1>
            <p className="text-base text-gray-600 dark:text-gray-300 mb-8" data-testid="not-found-text">{t("pageNotFoundText")}</p>
            <div className="flex flex-wrap items-center justify-center gap-3">
                <Button asChild className="bg-brand-red hover:bg-brand-red-dark rounded-sm px-6">
                    <Link to={p || "/"} data-testid="not-found-home"><Home className="w-4 h-4" /> {t("backHome")}</Link>
                </Button>
                <Button asChild variant="outline" className="rounded-sm px-6 dark:text-white dark:border-gray-600">
                    <Link to={`${p}/search`} data-testid="not-found-search"><Search className="w-4 h-4" /> {t("searchNews")}</Link>
                </Button>
            </div>
        </div>
    );
}
